import React, { Component } from 'react';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import ReduxFormField from '../../common/forms/ReduxFormsField';

const validate = values => {
  const errors = {};
  const { availability } = values;

  if (!availability || !availability.trim()) {
    errors.availability = ['Availability is required'];
  } else if (availability.trim().length > 255) {
    errors.availability = ['Availability cannot be longer than 255 characters'];
  }

  return errors;
};

class FollowUpEditAvailabilityForm extends Component {
  static propTypes = {
    ...formPropTypes,
  };

  onSubmit = values => {
    return this.props.onSubmit({
      availability: values.availability.trim(),
    });
  };

  render() {
    const { handleSubmit, onCancel, submitting } = this.props;

    return (
      <div className="admin-paper__edit-content">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field name="availability" component={ReduxFormField} label="Availability" required={true}>
            <input type="text" />
          </Field>
          <div className="admin-paper__edit-content__button-row">
            <div>
              <button type="button" className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
                Cancel
              </button>
              <button type="submit" className="button" disabled={submitting}>
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'followUpEditAvailabilityForm',
  onSubmitFail: () => {
    window.scrollTo(0, 0);
  },
  validate,
})(FollowUpEditAvailabilityForm);



// WEBPACK FOOTER //
// ./src/follow-ups/home/FollowUpEditAvailabilityForm.js